import React from 'react';
import { ContentUIComponent } from '../../model/Enum';
import { MetadataKeyOptionsMap, MetadataKeyReadonlyOptionsMap } from '../utils/SelectableOptions';
import MetadataCheckboxInput from '../workflow-viewer/content/MetadataCheckboxInput';
import MetadataMultiselectInput from '../workflow-viewer/content/MetadataMultiselectInput';
import MetadataSelectInput from '../workflow-viewer/content/MetadataSelectInput';
import MetadataStringInput from '../workflow-viewer/content/MetadataStringInput';
import { TechDomainDetails } from '@amzn/awscat-pattern-library-service-model';

interface Props {
  templateSchema: any;
  visible?: boolean;
  disabled?: boolean;
  readonly?: boolean;
  templateData?: any;
  showValidationError?: boolean;
  onInputUpdated?: (sectionId: string, value: any, validationError?: string) => void;
  onValidationError?: (label: string) => (validationError?: string) => void;
}

class TemplateMetadataForm extends React.Component<Props, any> {
  private static defaultProps = {
    disabled: false,
    readonly: false,
    showValidationError: true,
    templateData: {},
    visible: false,
  };

  // @ts-expect-error TS7006 - strict migration
  constructor(props) {
    super(props);
  }

  public render() {
    const { templateSchema, visible, templateData } = this.props;
    if (!visible || !templateSchema) {
      return null;
    }

    const metaAttributes = Object.keys(templateSchema.properties);
    const templateForm = metaAttributes.map((key) => {
      const prop = templateSchema.properties[key];
      if (!prop) {
        return null;
      }

      const isRequired: boolean = !!(
        Array.from(templateSchema.required) && templateSchema.required.includes(key)
      );

      return <div key={key}>{this.renderUIComponent(key, prop, templateData, isRequired)}</div>;
    });
    return templateForm;
  }

  // @ts-expect-error TS7030 - strict migration
  private renderUIComponent = (
    key: string,
    jsonSchemaProp: any,
    templateData: any,
    isRequired: boolean = false,
  ) => {
    const { disabled, visible, onValidationError, onInputUpdated, showValidationError, readonly } =
      this.props;
    const { UIComponent, label, description, contextualHelp, maxNumber } = jsonSchemaProp;
    const metadataOptionMap = readonly ? MetadataKeyReadonlyOptionsMap : MetadataKeyOptionsMap;
    switch (UIComponent) {
      case ContentUIComponent.MetadataStringInput:
        return (
          <MetadataStringInput
            sectionId={key}
            value={templateData[key]}
            label={label}
            description={description}
            contextualHelp={contextualHelp}
            placeholder={`Input ${label}`}
            onInputUpdated={onInputUpdated}
            onValidationError={onValidationError && onValidationError(label)}
            readonly={readonly}
            isRequired={isRequired}
            stretch
            showValidationError={showValidationError}
            disabled={disabled}
            visible={visible}
          />
        );
      case ContentUIComponent.MetadataSelectInput:
        const singleSelectDetailsMap = new Map<string, any>([
          ['mainTechDomain', TechDomainDetails],
        ]);
        return (
          <MetadataSelectInput
            sectionId={key}
            label={label}
            description={description}
            contextualHelp={contextualHelp}
            readonly={readonly}
            isRequired={isRequired}
            disabled={disabled}
            showValidationError={showValidationError}
            selectedId={templateData[key]}
            selectOptions={metadataOptionMap.get(key) || []}
            onSelectUpdated={onInputUpdated}
            onValidationError={onValidationError && onValidationError(label)}
            stretch
            placeholder={`Choose ${label}`}
            visible={visible}
            detailsMap={singleSelectDetailsMap.get(key)}
          />
        );
      case ContentUIComponent.MetadataMultiselectInput:
        return (
          <MetadataMultiselectInput
            sectionId={key}
            label={label}
            description={description}
            contextualHelp={contextualHelp}
            readonly={readonly}
            isRequired={isRequired}
            disabled={disabled}
            showValidationError={showValidationError}
            selectedIds={templateData[key]}
            selectOptions={metadataOptionMap.get(key) || []}
            onSelectsUpdated={onInputUpdated}
            onValidationError={onValidationError && onValidationError(label)}
            stretch
            placeholder={`Select ${label}`}
            maxNumber={maxNumber}
          />
        );
      case ContentUIComponent.MetadataCheckboxInput:
        return (
          <MetadataCheckboxInput
            sectionId={key}
            label={label}
            description={description}
            contextualHelp={contextualHelp}
            isChecked={!!templateData[key]}
            onChange={onInputUpdated}
            readonly={readonly}
            disabled={disabled}
          />
        );
    }
  };
}

export default TemplateMetadataForm;
